/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["select[_ngcontent-%COMP%]{font-size:1rem;width:4.3rem;-webkit-transition:.3s;transition:.3s;cursor:pointer;text-align:justify;-moz-text-align-last:center;text-align-last:center}select[_ngcontent-%COMP%]   option[_ngcontent-%COMP%]:disabled{background-color:#929292}"];
export { styles as styles };
